'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');
var LibrarySection = require('./library__section.js');
var Icons = require('../../../ui-icons/releases/bundle/rounded-bold-icons-bundle.js');

/**
 * Creates a Library
 *
 * @class
 */

class Library extends Core {

    _defaults() {
        return {
            target: '',
            fields: {}
        };
    }

    constructor(options) {
        super(options);
//TODO: extract preview pane
        this.template = `
            <div class='editor__library js-editor__library' style='display: none'>
                <div class='editor__library__top js-editor__library__top'>
                    <div class='editor__library__top__type'>
                        <div class='editor__library__top__type__text'>Type</div>
                    </div>

                    <div class='editor__library__top__name'>
                        <div class='editor__library__top__name__text'>Name</div>
                        <div class='editor__library__top__name__sort__arrow'><%= embedded_svg("icon-dropdown-arrow") %></div>
                    </div>

                    <div class='editor__library__top__summary'>
                        <div class='editor__library__top__summary__text'>Summary</div>
                    </div>

                    <div class='editor__library__top__version'>
                        <div class='editor__library__top__version__text'>Version</div>
                    </div>

                    <div class='editor__library__top__date'>
                        <div class='editor__library__top__date__text'>Date Created</div>
                        <div class='editor__library__top__date__sort__arrow'><%= embedded_svg("icon-dropdown-arrow") %></div>
                    </div>

                    <div class='editor__library__top__alert__info'>
                    </div>
                </div>

                <div class='editor__library__sections'></div>
            </div>

            <div class='editor__library__preview'>
                <div class='editor__library__preview__library__name'><%= name %></div>
                <div class='editor__library__preview__library__details'>
                    <div class='editor__library__preview__library__details__header'>Library Info</div>
                    <div class='editor__library__preview__library__asset__info'>
                        <table>
                            <tbody>
                                <tr class='editor__library__preview__library__asset__info__components'>
                                    <td class='editor__library__preview__library__asset__info__component__text'>Components</td>
                                    <td class='editor__library__preview__library__asset__info__component__count'><%- asset_count['component'] %></td>
                                </tr>

                                <tr class='editor__library__preview__library__asset__info__symbols'>
                                    <td class='editor__library__preview__library__asset__info__symbol__text'>Symbols</td>
                                    <td class='editor__library__preview__library__asset__info__symbol__count'><%- asset_count['symbol'] %></td>
                                </tr>

                                <tr class='editor__library__preview__library__asset__info__packages'>
                                    <td class='editor__library__preview__library__asset__info__package__text'>Packages</td>
                                    <td class='editor__library__preview__library__asset__info__package__count'><%- asset_count['package'] %></td>
                                </tr>

                                <tr class='editor__library__preview__library__asset__info__footprints'>
                                    <td class='editor__library__preview__library__asset__info__footprint__text'>Footprints</td>
                                    <td class='editor__library__preview__library__asset__info__footprint__count'><%- asset_count['footprint'] %></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class='editor__library__preview__library__info'>
                       <table>
                            <tbody>
                                <tr class='editor__library__preview__library__info__user'>
                                    <td class='editor__library__preview__library__info__user__text'>
                                        User
                                    </td>
                                    <td class='editor__library__preview__library__info__user__value'>
                                        <%- user %>
                                    </td>
                                </tr>

                                <tr class='editor__library__preview__library__info__date'>
                                    <td class='editor__library__preview__library__info__date__text'>
                                        Date Modified
                                    </td>
                                    <td class='editor__library__preview__library__info__date__value'>
                                        <%- date %>
                                    </td>
                                </tr>

                                <tr class='editor__library__preview__library__info__summary'>
                                    <td class='editor__library__preview__library__info__summary__text'>
                                        Summary
                                    </td>
                                    <td class='editor__library__preview__library__info__summary__value'>
                                        <%- summary %>
                                    </td>
                                </tr>
                            </tbody>
                       </table>
                    </div>
                </div>
            </div>
        `;

        super.render();

        this._openAll = true;

        //close all
        if(!this._openAll) this._closeAll();

        //app config
        this.configuration = options.fields["configuration"];

        this._initDOMEvents();
        this._initSortArrow();
    }

    _initDOMEvents() {
        var self = this;

        $('.editor__library__preview').on('swiperight', function() {
            //console.log('HIDDING PREVIEW PANE...');
        });

        //sort config
        var sortConfig = this.configuration.sortByColumns;

        if(sortConfig.enable) {
            sortConfig.sortablesColumnsKey.forEach(function(key) {
                var sortColumnHeaderTarget = '.editor__library__top__' + key.toLowerCase();
                var sortArrowTarget = '.editor__library__top__' + key.toLowerCase() + '__sort__arrow';

                //mouse hover events: show sort arrow on mouse hover on column header
                $(sortColumnHeaderTarget).hover(function() {
                    $(sortArrowTarget).addClass('hover');

                    //reset sort arrow direction for inactive sort columns
                    self._resetSortArrowDirectionForInactiveSortColumn(sortArrowTarget);
                }, function() {
                    $(sortArrowTarget).removeClass('hover');
                });

                //sort click events
                $(sortColumnHeaderTarget).on('click', {key: key.toLowerCase()}, self._sortByColumnClicked);
            });
        }
    }

    _initSortArrow() {
        var sortConfig = this.configuration.sortByColumns;

        if(!sortConfig.enable) return;

        //set default sort arrow active
        this._setSortArrowActive('.editor__library__top__' + sortConfig.defaultSortKey + '__sort__arrow');
    }

    _sortByColumnClicked(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:LibraryColumn:SortByColumn:clicked', e.data);
    }

    _setSortArrowActive(target) {
        $(target).addClass('active');
    }

    setSortArrowInactive(key) {
        var target = '.editor__library__top__' + key + '__sort__arrow';
        $(target).removeClass('active');
    }

    _flipSortArrow(target, direction) {
        if(direction === 'desc') {
            $(target).addClass('flipped');
        } else if(direction === 'asc') {
            $(target).removeClass('flipped');
        }
    }

    _resetSortArrowDirectionForInactiveSortColumn(target) {
        if($(target).hasClass('flipped') && !$(target).hasClass('active')) {
            $(target).removeClass('flipped');
        }
    }

    updateSortArrow(key, direction) {
        var sortArrowClass = '.editor__library__top__' + key + '__sort__arrow';

        //set current sort arrow active
        this._setSortArrowActive(sortArrowClass);

        //flip current sort arrow
        this._flipSortArrow(sortArrowClass, direction);
    }

    addSection(title, asset_count){
        return new LibrarySection({
            target: $('.editor__library__sections', this.$el),
            fields: {
                'title': title,
                'asset_count': asset_count
            }
        });
    }

    /**
     * Update asset count number in preview
     * @param  {string} type  Asset type
     * @param  {number} newCount Count
     */
    updateAssetCount(type, newCount) {
        //in libray preview
        var renderTarget1 = $('.editor__library__preview__library__asset__info__' + type + '__count');
        if(renderTarget1.length > 0 ) {
            renderTarget1.text(newCount);
        }
    }

    /**
     * Show update buttons for the selected asset in preview pane
     */
    showUpdateButtonInPreviewPane() {
        $('.editor__library__preview__asset__update', this.$el).addClass('editor__library__preview__asset__update--show');
    }

    /**
     * Hide update button for the asset in preview pane
     */
    _hideUpdateButtonInPreviewPaneForClickedAsset() {
        $('.editor__library__preview__asset__update', this.$el).removeClass('editor__library__preview__asset__update--show');
    }

    /**
     * Show alert icons in parent list in preview pane
     */
    showAlertIconInParentListInPreviewPaneForClickedAsset() {
        var parentListContainer = $('.editor__library__preview__asset__parent__list', this.$el);
        parentListContainer.find('.editor__library__preview__asset__parent__list__alert__update').addClass('editor__library__preview__asset__parent__list__alert__update--show');
    }

    /**
     * Hide alert icons in parent list in preview pane
     */
    _hideAlertIconForUpdateInPreviewPaneForClickedAsset() {
        var parentListContainer = $('.editor__library__preview__asset__parent__list', this.$el);
        parentListContainer.find('.editor__library__preview__asset__parent__list__alert__update').removeClass('editor__library__preview__asset__parent__list__alert__update--show');
    }

    /**
     * Hide UI elements for update for selected asset in preview pane
     */
    hideUIElementsForUpdateInPreviewPaneForClickedAsset() {
        //hide alert icons
        this._hideAlertIconForUpdateInPreviewPaneForClickedAsset();

        //hide update button
        this._hideUpdateButtonInPreviewPaneForClickedAsset();
    }

    _togglePreview(e) {
        var $preview = $('.editor__library__preview');
        $preview.toggle('slide');
        $preview.toggleClass('visible');
    }


    showPreviewIfPossible() {
        var previewEl = $('.editor__library__preview');
        if (!previewEl.hasClass('visible') && $(window).width() < 768) {
            this._togglePreview();
        }
    }

    clearPreview() {
        var previewEl = $('.editor__library__preview');
        previewEl.empty();
        previewEl.append(`<div class='editor__library__preview__editor'></div>`);
        previewEl.append(`<div class='editor__library__preview__details'></div>`);
    }

    /*
     * Load asset preview content in an iframe [load corresponding asset editor in view mode]
     */
    loadAssetPreviewEditor(url) {
        //asset preview content
        $('.editor__library__preview__editor').html(`<iframe src='` + url + `' frameBorder="0"/>`);
    }

    /**
     * @param  {object} info Asset info
     */
    updatePreviewPaneWithAssetInfo(info) {
        var self = this;
        var parents = info['parent_details'];
        var children = info['child_details'];

        //header: asset name and edit button, update and close button
        var assetDetailsTemplate =
            `<div class='editor__library__preview__asset__header'>
                <div class='editor__library__preview__asset__name'>
                    <%- name %>
                </div>
                <% if(edit_button) { %>
                    <div class='editor__library__preview__asset__edit'>
                        <a class='btn btn--s btn--none_level2_borders btn--hover--accent_none_accent'>
                            <div class="btn__txt">Edit</div>
                        </a>
                    </div>
                <% } %>
                <div class='editor__library__preview__asset__update'>
                    <a class='btn btn--s btn--none_level2_borders btn--hover--accent_none_accent'>
                        <div class="btn__txt">Update</div>
                    </a>
                </div>
                <div class='editor__library__preview__asset__close'>
                    <a class='btn btn--s btn--none_level2_borders btn--hover--accent_none_accent'>
                        <div class="btn__txt">Close</div>
                    </a>
                </div>
            </div>`;

        assetDetailsTemplate +=
            `<div class='editor__library__preview__asset__details'>
                <table><tbody>
                    <tr class='editor__library__preview__asset__info__type'>
                        <td class='editor__library__preview__asset__info__text'>
                            Type
                        </td>
                        <td class='editor__library__preview__asset__info__value'>
                            <%- type_name %>
                        </td>
                    </tr>

                    <tr class='editor__library__preview__asset__info__user'>
                        <td class='editor__library__preview__asset__info__text'>
                            User
                        </td>
                        <td class='editor__library__preview__asset__info__value'>
                            <%- user_name %>
                        </td>
                    </tr>

                    <tr class='editor__library__preview__asset__info__version'>
                        <td class='editor__library__preview__asset__info__text'>
                            Version
                        </td>
                        <td class='editor__library__preview__asset__info__value'>
                            <%- version_name %>
                        </td>
                    </tr>

                    <tr class='editor__library__preview__asset__info__date'>
                        <td class='editor__library__preview__asset__info__text'>
                            Date Created
                        </td>
                        <td class='editor__library__preview__asset__info__value'>
                            <%- date_created %>
                        </td>
                    </tr>

                    <tr class='editor__library__preview__asset__info__summary'>
                        <td class='editor__library__preview__asset__info__text'>
                            Summary
                        </td>
                        <td class='editor__library__preview__asset__info__value'>
                            <%- summary %>
                        </td>
                    </tr>
                </tbody></table>
            </div>`;

        var assetDetailsEl = _.template(assetDetailsTemplate)(info);

        var $previewAssetDetailsContainer = $('.editor__library__preview__details');
        $previewAssetDetailsContainer.append(assetDetailsEl);

        $('.editor__library__preview__asset__close').on('click', self._togglePreview);


        //attach event listeners
        if(info['edit_button']) {
           $('.editor__library__preview__asset__edit').on('click', {info: info}, self._openAssetUrl);
        }
        $('.editor__library__preview__asset__update').on('click', {info: info}, self._updateAsset);

        //add section separator if either a child or parent exists
        if(children.length > 0 || parents.length > 0) {
            $previewAssetDetailsContainer.append('<hr>');
        }

        //ADD CHILD DETAILS
        if(children.length > 0) {
            //append child list table
            $previewAssetDetailsContainer.append(
                `<div class='editor__library__preview__asset__child__list'>
                    <div class='editor__library__preview__asset__child__list__header'>Contains</div>
                    <table>
                        <tbody class='editor__library__preview__asset__child__list__body'>
                        </tbody>
                    </table>
                </div>`
            );

            //append child lists in the table body
            this._addChildList($('.editor__library__preview__asset__child__list__body'), children);
        }

        //ADD PARENT DETAILS
        if(parents.length > 0) {
            $previewAssetDetailsContainer.append(
                `<div class='editor__library__preview__asset__parent__list'>
                    <div class='editor__library__preview__asset__parent__list__header'>Used In</div>
                    <table>
                        <tbody class='editor__library__preview__asset__parent__list__body'>
                        </tbody>
                    </table>
                </div>`
            );

            this._addParentList($('.editor__library__preview__asset__parent__list__body'), parents);
        }

        //show UI for update if the asset is outdated or update button is displayed on row (select row, update is available, switch row and select this row again)
        if(info['is_outdated']) {
            this.showUpdateButtonInPreviewPane();
        }
    }

    //TODO: should probably be called from outside the templates
    _addChildList(targetNode, children) {
        var self = this;

        var childDetailsTemplate = _.template(`
            <tr class='editor__library__preview__asset__child__list__row'>
                <td class='editor__library__preview__asset__child__list__type'>
                    <%= icon %>
                </td>
                <td class='editor__library__preview__asset__child__list__name'>
                    <%- name %>
                </td>
                <td class='editor__library__preview__asset__child__list__summary'>
                    <%- summary %>
                </td>
                <td class='editor__library__preview__asset__child__list__edit__container'>
                    <% if(editable) { %>
                        <div class='editor__library__preview__asset__child__list__edit'>
                            <a class='btn btn--s btn--none_level2_borders btn--hover--accent_none_accent'>
                                <div class="btn__txt">Edit</div>
                            </a>
                        </div>
                    <% } %>
                </td>
            </tr>
        `);
        children.forEach(function(child) {
            child['icon'] = Icons[child['icon']];
            var childDetails = childDetailsTemplate(child);
            targetNode.append(childDetails);

            if(child['editable']) {
                $('.editor__library__preview__asset__child__list__edit').on('click',
                    {
                        info: {
                            'id': child['id'],
                            'type': child['type'],
                            'version_number': child['version_number']
                        }
                    },
                    self._openAssetUrl
                );
            }
        });
    }

    _addParentList(targetNode, parents) {
        var self = this;
        var parentDetailsTemplate = _.template(`
            <tr class='editor__library__preview__asset__parent__list__row'>
                <td class='editor__library__preview__asset__parent__list__type'>
                    <%= icon %>
                </td>
                <td class='editor__library__preview__asset__parent__list__name'>
                    <%- name %>
                </td>
                <td class='editor__library__preview__asset__parent__list__summary'>
                    <%- summary %>
                </td>
                <td class='editor__library__preview__asset__parent__list__edit__container'>
                    <% if(editable) { %>
                        <div class='editor__library__preview__asset__parent__list__edit'>
                            <a class='btn btn--s btn--none_level2_borders btn--hover--accent_none_accent'>
                                <div class="btn__txt">Edit</div>
                            </a>
                        </div>
                    <% } %>
                </td>
                <div class='editor__library__preview__asset__parent__list__alert__update'>
                    <a class='editor__library__preview__asset__parent__list__alert__update__link'>` + Icons['icon-warning'] + `</a>
                </div>
            </tr>
        `);
        parents.forEach(function(p) {
            p['icon'] = Icons[p['icon']];
            var parentDetails = parentDetailsTemplate(p);
            targetNode.append(parentDetails);

            if(p['editable']) {
                $('.editor__library__preview__asset__parent__list__edit').on('click',
                    {
                        info: {
                            'id': p['id'],
                            'type': p['type'],
                            'version_number': p['version_number']
                        }
                    },
                    self._openAssetUrl.bind(self));
            }

            //tooltip for parent list
            $('.editor__library__preview__asset__parent__list__alert__update').trigger('Cioui:showUpdateParentTooltip');
        });
    }

    _openAssetUrl(e) {
        e.stopImmediatePropagation();
        var info = e.data.info;
        $(e.currentTarget).trigger('Cioui:openAssetUrl', {
            id: info['id'],
            type: info['type'],
            versionNumber: info['version_number']
        });
    }

    _updateAsset(e) {
        e.stopImmediatePropagation();
        var info = e.data.info;
        $(e.currentTarget).trigger('Cioui:updateAsset', {
            id: info['id'],
            type: info['type'],
            versionNumber: info['version_number']
        });
    }
}

module.exports = Library;